import { Component, computed, ElementRef, inject, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent, FeatureComponent, IFeature, SliderComponent, TextHtmlComponent } from '@sirius/common';
import { InfoBoxComponent } from '../info-box/info-box.component';
import { KeyBenefitsComponent } from '../key-benefits/key-benefits.component';
import { ResultPageHeaderComponent } from '../result-page-header/result-page-header.component';
import { PROCESS_INFORMATION } from 'matchmaking/constants';
import { CaseStoriesComponent } from '../case-stories/case-stories.component';
import { BlogPostsComponent } from '../blog-posts/blog-posts.component';
import { EbooksComponent } from '../ebooks/ebooks.component';
import { CardProductCommerce } from 'commerce/models';
import { ProductSliderComponent } from 'shared';
import { MatchmakingDataService, MatchmakingTranslateService } from 'matchmaking/services';
import { InterpolatePipe } from 'shared/pipes';
import { EbooksContent, MediaContent } from 'matchmaking/models';

@Component({
    selector: 'matchmaking-result-page',
    imports: [CommonModule, InfoBoxComponent, KeyBenefitsComponent, ResultPageHeaderComponent, CaseStoriesComponent, BlogPostsComponent, ProductSliderComponent, EbooksComponent, InterpolatePipe, ButtonComponent, FeatureComponent, SliderComponent, TextHtmlComponent],
    templateUrl: './result-page.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './result-page.component.scss'
})
export class ResultPageComponent {
    dataService = inject(MatchmakingDataService);
    translateService = inject(MatchmakingTranslateService);

    webinarsForYouContent = input.required<IFeature>();
    academyTrainingContent = input.required<IFeature>();
    caseStories = input<MediaContent[] | undefined>([]);
    blogs = input<MediaContent[] | undefined>([]);
    products = input<CardProductCommerce[] | undefined>([]);
    ebooks = input<EbooksContent[] | undefined>([]);

    userName = computed(() => this.dataService.config()?.firstName ?? '');
    application = computed(() => this.dataService.selectedApplicationTitle());
    translations = computed(() => this.translateService.translations());
    industry = computed(() => this.dataService.selectedIndustryTitle());
    academyTrainingElementRef = viewChild<ElementRef, ElementRef>('academyTrainingElement', { read: ElementRef });
    highlights = computed(() => PROCESS_INFORMATION);

    getTranslation(key: string) {
        return this.translateService.getTranslation(key);
    }

    scrollToAcademyTraining() {
        this.academyTrainingElementRef()?.nativeElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
}
